import styled from 'styled-components';
import {useHistory} from "react-router-dom";
import {themecolors} from "../utils/themecolors";

const Tabs = [{'Overview': 'overview'}, {'Posts': 'post'}, {'Comments': 'comment'}];

const Container = styled.div``;
const Inner = styled.div``;
const FeedBarActive = styled.div``;

const Items = styled.div``;
const Item = styled.div``;

const ProfileToggles = styled(({className, activeTopic = "overview"}) => {

    const history = useHistory();

    const handleTopic = async (topicName, topicValue) => {
        history.replace(`?type=${topicValue}`);
    };

    return (
        <Container className={className}>
            <Inner>
                <Items>
                    {Tabs?.map((topic) => {
                        const [topicName, topicValue] = Object.entries(topic)[0];
                        return (
                            <Item className={topicValue === activeTopic.toLowerCase() ? 'active-feed' : ''} onClick={() => handleTopic(topicName, topicValue)} key={topicName}>
                                {topicName}
                            </Item>
                        );
                    })}
                </Items>
            </Inner>
        </Container>
    );
})`
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_1 : '#fff'};
  width: 100%;
  display: flex;
  flex-direction: row;
  font-weight: 600;
  
  ${Inner} {
    margin: 0 auto;
    font-size: 18px;
    padding: 12px 0 4px 0;
    display: flex;
    align-items: center;
    flex-grow: 1;
    max-width: 100%;
  }
  
  ${FeedBarActive} {
    margin-right: 24px;
    max-width: 332px;
    white-space: nowrap;
  }

  ${Item}:first-of-type {
    margin-left: 0;
  }
  ${Item} {
    border-radius: 48px;
    padding: 6px 16px;
    font-size: 15px;
    cursor: pointer;
    white-space: nowrap;
    margin-right: 4px;
    margin-left: 4px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_6 : '#eaeaea'};
    display: flex;
    align-items: center;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  }

  ${Items} {
    width: 100%;
    flex-grow: 1;
    padding: 0px 16px;
    display: flex;
    overflow: scroll;
    flex-shrink: 0;
    align-items: center;
    overflow: scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
  ${Items}::-webkit-scrollbar {
    display: none;
  }
  .active-feed {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'white' : 'black'};
    color: ${({theme}) => theme.color.name === 'dark' ? 'black' : '#fff'};
  }
  
`;

export default ProfileToggles;
